/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { IConnectionLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

interface IDnsClientInfo extends Pick<IConnectionLog,
'client_location' | 'dns_qtype' | 'protocol' | 'dns_tcp_conn_close_from_se'> {
    startTime?: string;
    endTime?: IConnectionLog['report_timestamp'];
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting DNS client info from an L4 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'dnsClientInfo',
})
export class DnsClientInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IConnectionLog): IDnsClientInfo {
        if (!log) {
            return {};
        }

        const {
            client_location,
            report_timestamp,
            total_time,
            dns_qtype,
            protocol,
            dns_tcp_conn_close_from_se,
        } = log;

        return {
            client_location,
            startTime: moment(report_timestamp).subtract(total_time, 'ms').toString(),
            endTime: report_timestamp,
            dns_qtype,
            protocol,
            dns_tcp_conn_close_from_se,
        };
    }
}
